import { render, staticRenderFns } from "./source.vue?vue&type=template&id=3d9fcbc4&scoped=true&"
import script from "./source.vue?vue&type=script&lang=ts&"
export * from "./source.vue?vue&type=script&lang=ts&"
import style0 from "./source.vue?vue&type=style&index=0&id=3d9fcbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9fcbc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VForm,VImg})
